import React, { useEffect, useRef } from "react";

/**
 * 
 * @param {*} DotsColor "RgbColor, example 200, 100, 100" 
 * @returns 
 */
const MatrixAnimation = ({ children, DotsColor, maxDotsCount = 50 }) => {
  const canvasRef = useRef(null);
  const points = [];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const createPoint = () => {
      return {
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 3 + 1,
        alpha: 0,
        fadeIn: true,
        speedX: Math.random() * 2 - 1,
        speedY: Math.random() * 2 - 1,
      };
    };

    const drawPoint = (point) => {
      ctx.beginPath();
      ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${DotsColor}, ${point.alpha})`;
      ctx.fill();
    };

    const connectPoints = (point1, point2) => {
      const distance = Math.sqrt(
        Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)
      );

      if (distance < 100) {
        const alpha = 1 - distance / 100;
        ctx.beginPath();
        ctx.moveTo(point1.x, point1.y);
        ctx.lineTo(point2.x, point2.y);
        ctx.strokeStyle = `rgba(${DotsColor}, ${alpha})`;
        ctx.lineWidth = 0.5;
        ctx.stroke();
      }
    };

    const updatePoint = (point) => {
      point.x += point.speedX;
      point.y += point.speedY;

      if (point.fadeIn) {
        point.alpha += 0.02;
        if (point.alpha >= 1) point.fadeIn = false;
      } else {
        point.alpha -= 0.01;
        if (point.alpha <= 0) {
          const index = points.indexOf(point);
          points.splice(index, 1);
        }
      }

      if (point.x < 0 || point.x > canvas.width) point.speedX *= -1;
      if (point.y < 0 || point.y > canvas.height) point.speedY *= -1;
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (points.length < maxDotsCount) {
        points.push(createPoint());
      }

      points.forEach((point, index) => {
        drawPoint(point);
        updatePoint(point);

        for (let j = index + 1; j < points.length; j++) {
          connectPoints(point, points[j]);
        }
      });

      requestAnimationFrame(animate);
    };

    // setInterval(()=>{
        animate()
    // }, 10000)

    return () => {
      points.length = 0; // Cleanup points
    };
  }, []);

  return (
    <div className="matrix-animation-container">
      <canvas ref={canvasRef} className="matrix-animation-canvas" />
      <div className="matrix-animation-content">{children}</div>
    </div>
  );
};

export default MatrixAnimation;


